import SectionProducts from './SectionProducts';

export default SectionProducts;
